<template>
    <v-dialog v-model="show" max-width="450px">
        <v-card>
            <v-card-title>Scan Barcode<v-spacer></v-spacer>
                <v-btn text small @click.stop="show=false"><i class="fa fa-times" aria-hidden="true"></i></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <StreamBarcodeReader @click="showCamera=true" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
            </v-card-text>
            <v-divider class="mt-12"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn text >Save</v-btn> -->
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { StreamBarcodeReader } from "vue-barcode-reader";
    export default {
        name: 'BarcodeScanner',
        components: {
            StreamBarcodeReader
        },
        props:['value'],
        data() {
            return {
                showCamera:false,
            }
        },
        computed: {
            show: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },
        },
        watch: {
            
        },

        created() {
  
        },
        methods: {
            onDecode(text){
                console.log("Scanning",text)
                this.decodedText = text
                this.barcodeNumber = text
                this.$emit("passBarcodeNumber", {
                  barcodeNumber: this.barcodeNumber,
                  showInputForBarcodeNumber: true
                });
                this.show = false

               
            },
        }
    }
</script>